const OS = require('../../models/environ/os');

/**
 * AddTapEvent
 * @class
 */
class AddTapEvent {

  eventType = 'click';

  /**
   * @instance
   * @param _$el {HTMLElement}
   * @param iosOnry {boolean}
   */
  constructor(_$el, iosOnry = true) {
    if(iosOnry && !OS.getInstance().ios) return;

    this.eventType = 'tap';

    this.$el = _$el;

    this.isTouch   = false;
    this.startTime = null;
    this.touchX    = null;
    this.touchY    = null;
    this.moveX     = null;
    this.moveY     = null;

    this.tapEvent = new CustomEvent('tap');

    this.events = {
      touchstart: this.createEvent(this.$el, 'touchstart', this.onTouchstarted.bind(this)),
      touchmove : this.createEvent(this.$el, 'touchmove', this.onTouchmoved.bind(this)),
      touchend  : this.createEvent(this.$el, 'touchend', this.onTouchended.bind(this)),
      mousedown : this.createEvent(this.$el, 'mousedown', this.onTouchstarted.bind(this)),
      mousemove : this.createEvent(this.$el, 'mousemove', this.onTouchmoved.bind(this)),
      mouseup   : this.createEvent(this.$el, 'mouseup', this.onTouchended.bind(this)),
    };
  }

  /**
   * @instance
   */
  add() {
    _.forEach(this.events, (_event) => {
      _event.add();
    });
  }

  /**
   * @instance
   */
  remove() {
    _.forEach(this.events, (_event) => {
      _event.remove();
    });
  }

  /**
   * @instance
   * @private
   */
  createEvent(_$el, _event, _cb) {
    return {
      handleEvent: (_e) => {
        _cb(_e);
      },
      add: function() {
        _$el.addEventListener(_event, this, false);
      },
      remove: function() {
        _$el.removeEventListener(_event, this, false);
      },
    };
  }

  /**
   * @instance
   * @private
   * @param _e {event}
   */
  onTouchstarted(_e) {
    if(this.isTouch) return;
    this.isTouch   = true;
    this.startTime = _e.timeStamp;

    if(typeof _e.changedTouches !== 'undefined' && _e.changedTouches !== null) {
      this.touchX = _e.changedTouches[0].pageX;
      this.touchY = _e.changedTouches[0].pageY;
    } else {
      this.touchX = _e.pageX;
      this.touchY = _e.pageY;
    }
  }

  /**
   * @instance
   * @private
   * @param _e {event}
   */
  onTouchmoved(_e) {
    if(!this.isTouch) return;
    if(typeof _e.changedTouches !== 'undefined' && _e.changedTouches !== null) {
      this.moveX = this.touchX - _e.changedTouches[0].pageX;
      this.moveY = this.touchY - _e.changedTouches[0].pageY;
    } else {
      this.moveX = this.touchX - _e.pageX;
      this.moveY = this.touchY - _e.pageY;
    }
    if(500 <= (_e.timeStamp - this.startTime)) {
      this.reset();
    }
  }

  /**
   * @instance
   * @private
   * @param _e {event}
   */
  onTouchended(_e) {
    if( this.isTouch &&
        (500 > (_e.timeStamp - this.startTime)) &&
        (-5 < this.moveX) && (5 > this.moveX) &&
        (-5 < this.moveY) && (5 > this.moveY) ) {
      _e.preventDefault();
      this.$el.dispatchEvent(this.tapEvent);
    }
    this.reset();
  }

  /**
   * @instance
   * @private
   */
  reset() {
    this.touchX  = null;
    this.touchY  = null;
    this.moveX   = null;
    this.moveY   = null;
    this.isTouch = false;
  }

}

/**
 * class exports
 */
module.exports = AddTapEvent;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/event/add-tap-event.js
 **/